import { messagesFromReasonCode, messagesFromReasonCodeOnHold, defaultMessage } from 'constants/afterSalesReasons';
import { bookingStatus } from 'types/booking';

export const getOverrideMessages = ({ reasonCode = '', status }) => {
  if (reasonCode) {
    return status === bookingStatus.ON_HOLD
      ? messagesFromReasonCodeOnHold[reasonCode] || defaultMessage
      : messagesFromReasonCode[reasonCode] || defaultMessage;
  }

  return null;
};
